<header class="mobile:bg-whiteshade dark:mobile:bg-black-dark">
  <div class="mb-3 flex justify-between items-center h-[38px]">
    <h2 class="!m-0 notifications-title max-mobile:pl-5 max-mobile:pr-4">
      {{ "NOTIFICATIONS" | translate }}
    </h2>
    <button
      (click)="openModal('dlt_notifications')"
      (keyup)="onKeyUp($event, 'openModal', 'dlt_notifications')"
      tabindex="0"
      class="remove"
    >
      <span
        class="block w-[24px] h-[24px] bg-black dark:bg-white mask-[url(/assets/images/icons/remove.svg)] mask-size-[24px_24px]"
      ></span>
    </button>
  </div>

  @if (!isPushEnabled && !user.hasDismissedPushPrompt) {
  <div
    class="enablePush bg-whitepale dark:bg-black-dark-light p-2 mb-4 rounded-lg border-t-[3px] border-primary"
  >
    <div class="flex justify-start gap-2 items-start">
      <div class="bg-primary p-1 rounded-lg">
        <span
          class="block w-[24px] h-[24px] bg-black mask-[url(/assets/images/icons/bell.svg)] mask-size-[24px_24px]"
        ></span>
      </div>
      <div>
        <h3 class="font-base font-bold text-[16px] leading-[24px] mb-2">
          {{ "PUSH_NOT_ENABLED_TITLE" | translate }}
        </h3>
        <p class="mt-0 font-normal">
          {{ "PUSH_NOT_ENABLED_TEXT" | translate }}
        </p>
      </div>
    </div>
    <div
      class="flex justify-end items-center gap-2 mt-2 pt-2 border-t border-borders-dark dark:border-black-dark-lighter"
    >
      <button
        class="btn btn-grad btn-small w-[120px] !text-base"
        (click)="enablePushNotifications()"
      >
        {{ "ENABLE" | translate }}
      </button>
      <button
        class="btn btn-transparent btn-small w-[120px] !text-base"
        (click)="dismissPushPrompt()"
      >
        {{ "LATER" | translate }}
      </button>
    </div>
  </div>
  }

  <div
    appSlidingTabIndicator
    class="flex gap-0 border-b border-borders-dark dark:border-black-dark-lighter mb-2"
  >
    <button
      class="font-normal px-2 cursor-pointer pb-1 mb-0 border-b-[3px] border-transparent"
      [class.!font-bold]="notificationsType === 'unread'"
      [attr.data-tab-active]="notificationsType === 'unread'"
      (click)="switchNotifications('unread')"
      (keyup)="onKeyUp($event, 'switchNotifications', 'unread')"
      tabindex="0"
    >
      {{ "UNREAD" | translate }}
    </button>

    <button
      class="font-normal px-2 cursor-pointer pb-1 mb-0 border-b-[3px] border-transparent"
      [class.!font-bold]="notificationsType === 'all'"
      [attr.data-tab-active]="notificationsType === 'all'"
      (click)="switchNotifications('all')"
      (keyup)="onKeyUp($event, 'switchNotifications', 'all')"
      tabindex="0"
    >
      {{ "ALL" | translate }}
    </button>
  </div>
</header>

@if ( notificationsToDisplay && notificationsToDisplay.length > 0) {
<ul
  class="overflow-y-scroll max-h-[calc(100vh-(var(--sab)*2+var(--sat))-105px)] pb-2 mobile:max-h-[498px]"
  [ngClass]="{
    'max-h-[calc(100vh-330px)]': !isPushEnabled && !user.hasDismissedPushPrompt
  }"
>
  @for (notification of notificationsToDisplay; track trackByFn($index,
  notification)) {
  <li class="mb-1">
    <app-notification
      [user]="user"
      [notification]="notification"
      [isOpened]="isOpened"
      [isMobile]="isMobile"
    ></app-notification>
  </li>
  }
</ul>
} @else {
<p class="italic font-normal mb-3">
  {{
    (notificationsType === "all" ? "NO_NOTIFICATION" : "NO_NEW_NOTIFICATION")
      | translate
  }}
</p>
} @if (isMobile) {
<app-modal
  [modalId]="'dlt_notifications'"
  [shouldSwipeDownToClose]="true"
  classes="!h-auto bottom-0 rounded-t-lg"
>
  <h2 class="text-center">
    {{ "DELETE_NOTIFICATIONS" | translate }}
  </h2>
  <div
    class="mt-5 flex justify-end items-center uppercase font-bold cursor-pointer text-[16px]"
  >
    <button
      (click)="closeModal('dlt_notifications')"
      (keyup)="onKeyUp($event, 'closeModal', 'dlt_notifications')"
      tabindex="0"
      class="uppercase"
    >
      {{ "NO_MY_BAD" | translate }}
    </button>
    <button
      (click)="deleteNotifications()"
      (keyup)="onKeyUp($event, 'deleteNotifications')"
      tabindex="0"
      class="ml-2 text-primary-text uppercase"
    >
      {{ "YES_PLEASE" | translate }}
    </button>
  </div>
</app-modal>
}
